import React from "react";
import ReactDOMServer from "react-dom/server";

function InvoicePDFHeaderSectionStatic(data) {
  const staticContent = (
    <div className="w-full flex flex-col">
      <div className="px-2 py-4 flex items-center gap-4">
        <img
          src={data?.companyLogo}
          alt=""
          className="object-contain w-28 h-2w-28"
        />
        <span className="font-bold text-5xl">{data?.companyName}</span>
      </div>
      <div className="w-full rounded-2xl p-6 bg-gray-50">
        <div className="w-full flex justify-between">
          <span className="font-bold text-xl">Invoice</span>
          <div className="flex flex-col items-end">
            <span className="text-gray-400 text-lg">Invoice No.</span>
            <span className="font-bold text-4xl">{data?.invoiceNo}</span>
          </div>
        </div>
        <div className="w-full flex flex-col">
          <div className="flex items-end">
            <div className="flex flex-col my-2 flex-1 gap-1">
              <span className="text-gray-400 text-lg">Customer</span>
              <span className="font-bold text-4xl">{data?.customerName}</span>
              <span className="text-lg">{data?.customerAddress}</span>
            </div>
            <div className="flex flex-col items-end">
              <span className="text-gray-400 text-lg">Issued on</span>
              <span className="text-lg">{data?.issuedOn}</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end">
          <span className="text-gray-400 text-lg mt-2">Payment due</span>
          <span className="text-lg">{data?.paymentDue}</span>
        </div>
      </div>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default InvoicePDFHeaderSectionStatic;
